// theme.js
import { createTheme } from "@mui/material/styles";

const buildPalette = (mode) => ({
    mode,
    primary: {
        main: "#ff9800", // dein Orange
        contrastText: "#fff",
    },
    secondary: {
        main: "#1565c0", // Blau für Akzente
    },
    background: {
        default: mode === "dark" ? "#0f1214" : "#fafafa",
        paper: mode === "dark" ? "#15191d" : "#fff",
    },
});

const createAppTheme = (mode = "light") =>
    createTheme({
        palette: buildPalette(mode),
        shape: {
        borderRadius: 12, // global für Cards, Buttons, Inputs
    },
        typography: {
        fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
        h1: {
            fontSize: "2rem",
            fontWeight: 700,
            letterSpacing: "-0.5px",
        },
        h2: {
            fontSize: "2rem",
            fontWeight: 700,
            letterSpacing: "-0.5px",
        },
        h3: {
            fontSize: "2rem",
            fontWeight: 700,
            letterSpacing: "-0.5px",
        },
        h4: {
            fontSize: "2rem",
            fontWeight: 700,
            letterSpacing: "-0.5px",
        },
        h5: {
            fontSize: "2rem",
            fontWeight: 700,
            letterSpacing: "-0.5px",
        },
        h6: {
            fontSize: "2rem",
            fontWeight: 700,
            letterSpacing: "-0.5px",
        },
        button: {
            textTransform: "none",
            fontWeight: 600,
        },
    },
    components: {
        MuiCard: {
            styleOverrides: {
                root: {
                    boxShadow: mode === "dark" ? "0 6px 24px rgba(0,0,0,0.45)" : "0 6px 24px rgba(0,0,0,0.06)",
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    padding: "10px 18px",
                },
                containedPrimary: {
                    backgroundColor: "#ff9800",
                    "&:hover": {
                        backgroundColor: "#cc7a00",
                    },
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                inputProps: {
                    lang: "de-DE",
                },
            },
            styleOverrides: {
                root: {
                    "& .MuiOutlinedInput-root": {
                        borderRadius: 12,
                    },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    minHeight: "48px", // Consistent height
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#ff9800", // Consistent focus color
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#cc7a00", // Consistent hover color
                    },
                    "&.Mui-disabled": {
                        backgroundColor: mode === "dark" ? "#1c1f24" : "#f5f5f5", // Consistent disabled background
                    },
                },
                input: {
                    padding: "12px 14px", // Consistent padding
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontSize: "0.9rem", // Consistent font size for labels
                    "&.Mui-focused": {
                        color: "#ff9800", // Consistent focus color for labels
                    },
                    "&.Mui-disabled": {
                        color: "#9e9e9e", // Consistent disabled color for labels
                    },
                },
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    fontSize: "0.75rem", // Consistent font size for helper text
                    margin: "3px 14px 0", // Consistent margin
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                select: {
                    minHeight: "48px", // Consistent height
                    padding: "12px 14px", // Consistent padding
                    "&:focus": {
                        borderRadius: 12, // Consistent border radius on focus
                        backgroundColor: "transparent", // Prevent background change on focus
                    },
                },
                outlined: {
                    borderRadius: 12, // Consistent border radius
                },
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    "& .MuiOutlinedInput-root": {
                        borderRadius: 12, // Consistent border radius
                        padding: "4px 14px", // Adjust padding for autocomplete
                    },
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: 12, // Consistent border radius for dialogs
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    padding: "16px 24px", // Consistent padding for dialog actions
                },
            },
        },
        },
    });

export default createAppTheme;
export { createAppTheme };
